import { DatePicker } from 'antd'
import type { DatePickerProps } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'

export const ReadonlyDatePicker = (props: DatePickerProps) => (
  <DatePicker {...props} inputReadOnly />
)

export const ReadonlyRangePicker = (props: RangePickerProps) => (
  <DatePicker.RangePicker {...props} inputReadOnly />
)
